export default {"src":"/_next/static/media/EXTR.6aca7d86.svg","height":18,"width":18};